<template>
<div class="teacher-records">
  <div class="flex collapse">
    <h2 class="recent">Teacher's Records</h2>
    <ChevronDownIcon class="icone" @click="toggleLearners" />
  </div>
  <div v-if="showLearners">
    <div
      v-for="learner in learners"
      :key="learner.id"
    >
      <ClassRecords
        :record="learner"
        @deletion="announcementDeletion"/>
    </div>
  </div>
</div>
</template>

<script>
import ClassRecords from './ClassRecordDetails.vue'
import { ChevronDownIcon } from '@heroicons/vue/outline'
import { ref } from '@vue/reactivity'
export default {
  components: { ClassRecords, ChevronDownIcon },
  props: ['learners'],
  emits: ['announcementdeletion'],
  setup (props, context) {
    const showLearners = ref(false)
    const announcementDeletion = ({ edit }) => {
      context.emit('announcementdeletion')
      if (edit) {
        context.emit('announcementdeletion', { edit: true })
      }
    }

    const toggleLearners = () => {
      showLearners.value = !showLearners.value
    }

    return { announcementDeletion, showLearners, toggleLearners }
  }
}
</script>

<style>
  .teacher-records {
    background: transparent;
  }
  .recent {
      color: #fff;
      margin-top: 0;
      margin-bottom: 5px;
    }
  .collapse {
    justify-content: space-between;
  }
  .icone {
    max-width: 30px;
    cursor: pointer;
  }
</style>
